import { render, staticRenderFns } from "./creat_by_ordinary.vue?vue&type=template&id=9599c53e&scoped=true&"
import script from "./creat_by_ordinary.vue?vue&type=script&lang=js&"
export * from "./creat_by_ordinary.vue?vue&type=script&lang=js&"
import style0 from "./creat_by_ordinary.vue?vue&type=style&index=0&id=9599c53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9599c53e",
  null
  
)

export default component.exports